class SearchExpander extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.trigger');
    this.expanderContainer = this.querySelector('.search-expander__main');
    this.searchForm = this.querySelector('form');
    this.searchInput = this.searchForm.q;
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => (this.expanderContainer.classList.contains('is-expanded') && this.searchInput.value.length > 0) ? this.searchForm.submit() : this.toggle());
    document.body.addEventListener('click', (event) => (this.expanderContainer.classList.contains('is-expanded') && !this.contains(event.target)) && this.toggle());
    this.searchInput.addEventListener('keydown', (e) => this.handleKeydown(e));
  }

  handleKeydown(event) {
    if(event.code.toUpperCase() === 'ESCAPE' || event.code.toUpperCase() === 'TAB') this.toggle();

    this.trigger.setAttribute('aria-label', (this.searchInput.value.length > 0) ? window.theme.strings.submitSearch : window.theme.strings.openSearch);
  }

  toggle(){
    if(blockCustomerActions) {
      window.theme.internalCustomerRidirect(true);
      return;
    }

    this.expanderContainer.classList.toggle('is-expanded');
    this.trigger.setAttribute('aria-expanded', this.expanderContainer.classList.contains('is-expanded'));
    this.trigger.setAttribute('aria-label', this.expanderContainer.classList.contains('is-expanded') ? window.theme.strings.closeSearch : (this.searchInput.value.length > 0) ? window.theme.strings.submitSearch : window.theme.strings.openSearch);

    if(this.expanderContainer.classList.contains('is-expanded')) this.searchInput.focus();
    else this.trigger.focus();
  }
}

if (!customElements.get('header-search-expander')) customElements.define('header-search-expander', SearchExpander);